export default function detectMobileDevice() {
    const toMatch = [
        /Android/i,
        /iPhone/i,
        /iPad/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}
